import script from "./Tree.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tree.vue?vue&type=script&lang=ts&setup=true"

import "./Tree.vue?vue&type=style&index=0&id=22d855c4&lang=scss"

const __exports__ = script;

export default __exports__